module.exports = __webpack_public_path__ + "img/aws-cloud-practitioner.0c96cccb.png";